import axios from 'axios';
import utils from '../../utils/util';
import BrowserEnvironment from './browser.environment';
import queryParams from '../pageQuery.service';
import config from '../../config';
export default class WechatEnvironment extends BrowserEnvironment {
  constructor () {
    super();
    this.weichatEnv = 'wx';
    this.scriptPromise = new Promise(function (resolve) {
      const datetime = Math.floor((new Date()).getTime() / (1000 * 3600));
      const wechatScriptUrl = '//res.wx.qq.com/open/js/jweixin-1.3.2.js?t=' + datetime;
      utils.loadScript({
        id: 'jweixin-1.3.2',
        src: wechatScriptUrl,
        callback: function () {
          resolve();
        }
      });
    });
  }
  getEnvInfo () {
    const self = this;
    return this.scriptPromise.then(() => {
      return new Promise((resolve) => {
        if (window.wx && window.wx.miniProgram) {
          window.wx.miniProgram.getEnv(function (res) {
            self.weichatEnv = res.miniprogram ? 'wxminapp' : 'wx';
            return resolve({ env: self.weichatEnv });
          });
        } else {
          return { env: self.weichatEnv };
        }
      });
    });
  }
  /**
  *设置wxapi配置
  */
  setWxConfig () {
    if (this.configPromise) {
      return this.configPromise;
    }
    this.configPromise = new Promise(function (resolve, reject) {
      let wx = window.wx;
      var debug = queryParams._isDebug === '1';
      axios
      .get(config.dealerCloud + '/vrExhibition/getWxParams', { params: { url: location.href.split('#')[0] } })
      .then((res) => {
         if(res.status===200) {
          let data = res.data;
          if (data) {
            wx.config({
              debug: debug,
              appId: data.appId,
              timestamp: data.timestamp,
              nonceStr: data.nonceStr,
              signature: data.signature,
              jsApiList: [
                'onMenuShareTimeline',
                'onMenuShareAppMessage',
                'onMenuShareQQ',
                'onMenuShareWeibo',
                'onMenuShareQZone'
              ]
            });
            resolve();
         }
        } else {
          reject(new Error('状态码错误'));
        }
      }).catch(error=>{
        reject(error);
      });
    });
    return this.configPromise;
  }
  /**
  * 设置微信分享
  * @param {*} shareData
  */
  wexinShare (shareData) {
    let self = this;
    let title = shareData.title;
    let desc = shareData.desc;
    let brandLogo = shareData.icon;
    let link = shareData.link;
    let wx = window.wx;
    wx.ready(function () {
      // 分享到朋友圈
      wx.onMenuShareTimeline({
        title: title, // 分享标题
        link: link, // 分享链接
        imgUrl: brandLogo, // 分享图标
        success: function () {
          self.execute(self.shareSuccessCallbacks);
        }
      });

      // 分享给朋友
      wx.onMenuShareAppMessage({
        title: title,
        desc: desc,
        link: link,
        imgUrl: brandLogo,
        success: function () {
          self.execute(self.shareSuccessCallbacks);
        }
      });

      // 分享到QQ
      wx.onMenuShareQQ({
        title: title,
        desc: desc,
        link: link,
        imgUrl: brandLogo,
        success: function () {
          self.execute(self.shareSuccessCallbacks);
        }
      });
      // 分享到腾讯微博
      wx.onMenuShareWeibo({
        title: title,
        desc: desc,
        link: window.location.href,
        imgUrl: brandLogo,
        success: function () {
          self.execute(self.shareSuccessCallbacks);
        }
      });

      // 分享到腾讯微博
      wx.onMenuShareWeibo({
        title: title,
        desc: desc,
        link: window.location.href,
        imgUrl: brandLogo,
        success: function () {
          self.execute(self.shareSuccessCallbacks);
        }
      });
      // 分享到QQ空间
      wx.onMenuShareQZone({
        title: title,
        desc: desc,
        link: window.location.href,
        imgUrl: brandLogo,
        success: function () {
          self.execute(self.shareSuccessCallbacks);
        }
      });
    });
  }
  // 设置小程序分享
  setMiniProgramShare (shareData) {
    let wx = window.wx;
    try {
      // 小程序环境下逻辑
      wx.miniProgram.postMessage({
        data: {
          title: shareData.title,
          path: shareData.link,
          imageUrl: shareData.icon
        }
      });
    } catch (ex) {
      console.error(ex);
    }
  }
  setShareData (opts) {
    super.setShareData(opts);
    let shareData = this.getShareData();
    let self = this;
    self.scriptPromise.then(function () {
      self.setWxConfig();
      if (self.weichatEnv === 'wxminapp') {
        self.setMiniProgramShare(shareData);
      } else {
        self.configPromise.then(function () {
          self.wexinShare(shareData);
        }).catch(function (error) {
          console.error(error);
        });
      }
    });
  }
}
